module.exports = __webpack_public_path__ + "media/images/icon-list-item-cda5622760370abad3068afb3cbaaec1.svg";